import { Component } from '@angular/core';

@Component({
  selector: 'uni-card-header-title',
  templateUrl: './uni-card-header-title.component.html',
  styleUrls: ['./uni-card-header-title.component.scss'],
})
export class UniCardHeaderTitleComponent {
}
